import React from 'react';
import { useCgu } from 'components/cgu/CguProvider';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

const SidebarCGU = () => {
  const { showCguModal } = useCgu();
    const { t } = useTranslation()

  return (
    <div className="">
      <Row className="">
        <Col>
          <button
            onClick={showCguModal}
            className="w-100"
            style={{
              backgroundColor: '#007acd',
              borderColor: 'rgb(8 176 77 / 64%)',
              color: 'white'
            }}
          >
           {t('sidebar.panel.cgu') }
          </button>
        </Col>
      </Row>
    </div>
  )
}

export default SidebarCGU
